'use client'

import {usePathname} from "next/navigation";
import {useEffect, useState} from "react";
import {TOURS} from "@/tours";
import {getRandomElement} from "@/lib/utils";
import {useOnborda} from "onborda";

export function useTour() {
    const pathname = usePathname();
    const { startOnborda } = useOnborda();
    const [localTours, setLocalTours] = useState<string[]>([]);
    const [tourName, setTourName] = useState<string>("");
    const [tourCount, setTourCount] = useState<number>(0);
    const [forceRefresh, setForceRefresh] = useState<number>(0);

    useEffect(() => {
        const pathParts = pathname.split("/");

        const localToursJson = localStorage.getItem("tours");
        const localTours = localToursJson ? JSON.parse(localToursJson) as string[] : [];
        setLocalTours(localTours);

        if(pathParts.includes("products")) {
            if(pathParts.length >= 6) {
                const productTours = TOURS.find(tour => tour.page === "product")?.tours ?? [];
                const availableTours = productTours.filter(tour => !localTours.includes(tour.tour));
                setTourCount(availableTours.length);

                if(availableTours.length > 0) {
                    const tour = getRandomElement(availableTours);
                    setTourName(tour.tour);
                }
            }
            else if(pathParts.length === 5) {
                "groupTour"
            } else if(pathParts.length === 4) {
                "familyTour"
            } else if(pathParts.length === 3) {
                "productsTour"
            }
        } else if(pathParts.includes("search")) {
            if(pathParts.length === 3) {
                "searchTour"
            }
        } else if(pathParts.includes("accessories")) {
            if(pathParts.length === 4) {
                "accessoriesTour"
            }
        } else if(pathParts.includes("projects")) {
            if(pathParts.length >= 4) {
                "projectTour"
            } else if(pathParts.length === 3) {
                "projectsTour"
            }
        }
    }, [pathname, forceRefresh]);

    const startTour = () => {
        if(tourCount <= 0) return;

        startOnborda(tourName);
        localStorage.setItem("tours", JSON.stringify([...localTours, tourName]));
        setForceRefresh(prev => prev + 1);
    }

    // useEffect(() => {
    //     if(!tourName) return;
    //
    //     const timeout = setTimeout(() => startOnborda(tourName), 500);
    //
    //     return () => clearTimeout(timeout);
    // }, [startOnborda, tourName])

    return {tourName, tourCount, startTour};
}